/**
 * Pickadate
 */


(function ($) {


	var $pickerInput = $('[data-datepicker]');

	var pickerToggle = '[data-datepicker-toggle]',
		pickerToggleIcon = 'ui_calendar',
		pickerToggleCloseIcon = 'ui_close';


	$pickerInput.each(function(i) {

		var $this = $(this);

		// Datepicker with options
		$this.pickadate({
			close: '',
			format: 'dd.mm.yyyy',
			formatSubmit: 'yyyy-mm-dd',

			// Toggle pickerToggle icon
			onOpen: function() {
				$this.nextAll(pickerToggle).attr( 'data-icon', pickerToggleCloseIcon );
			},
			onClose: function() {
				$this.nextAll(pickerToggle).attr( 'data-icon', pickerToggleIcon );
			}
		});


		// This datepicker
		var thisPicker = $this.pickadate('picker');


		// When clicking datepicker toggle
		$this.nextAll(pickerToggle).
		on( 'click', function( event ) {

			if ( thisPicker.get( 'open' ) ) {
				thisPicker.close();
				event.preventDefault();
			}
			else {
				thisPicker.open();
				event.preventDefault();
			}
			event.stopPropagation()
		}).
		on( 'mousedown', function(event) {
			event.preventDefault()
		});

	});

})(jQuery);
